const MODELS = {
  INVOICE: 'invoice',
  RECEIPT: 'receipt',
  SALES: 'sales',
  BANK_STATEMENT: 'BS',
  CREDIT_CARD_STATEMENT: 'CC',
};

export default MODELS;
